<template>
  <div>
    <PulseLoader
      class="loading"
      :loading="state == 'loading'"
      color="#f1d85b"
      size="20px"
    />
    <ErrorView v-if="state == 'error'" />
    <div v-if="state == 'display'">
      <nav>
        <SubjectLink
          v-for="subject in subjects"
          :key="subject"
          :to="`/about/teachers/${schoolLevel}/${subject}`"
          :subject="getSubjectName(subject)"
        />
      </nav>
      <TeacherList :teachers="subjectTeachers" />
    </div>
  </div>
</template>

<script>
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';

import SubjectLink from '@/components/SubjectLink.vue';
import TeacherList from '@/components/TeacherList.vue';
import ErrorView from '@/components/ErrorView.vue';
import { withApiClient } from '@/api/ApiClient.js';
import { getSubjectName } from '@/utils/subjects.js';
// import _ from "lodash";

const IntroduceTeachers = {
  components: {
    SubjectLink,
    TeacherList,
    PulseLoader,
    ErrorView,
  },
  data() {
    return {
      state: 'idle',
      teachers: [],
    };
  },
  mounted() {
    this.fetchTeachers();
  },
  watch: {
    $route() {
      this.fetchTeachers();
    },
  },
  computed: {
    subjects() {
      const teachers = this.teachers
        .map((it) => it.subject)
        .reduce((acc, it) => [...acc, it], []);
      let sortBy = [
        'chinese',
        'math',
        'society',
        'natural',
        'english',
        'physical',
        'chemistry',
        'biology',
        'history',
        'geography',
        'citizen',
      ];

      let array = [];
      for (let subject of sortBy) {
        if (teachers.indexOf(subject) >= 0) {
          array.push(subject);
        }
      }
      return array;
    },
    schoolLevel() {
      return this.$route.params.school_level;
    },
    subjectTeachers() {
      return this.teachers.filter(
        (it) => it.subject == this.$route.params.subject
      );
    },
  },
  methods: {
    fetchTeachers() {
      this.state = 'loading';
      this.apiClient
        .fetchTeachers(this.$router.currentRoute.params.school_level)
        .subscribe(
          (resp) => {
            this.teachers = resp.list;
            if (this.subjects.length > 0 && !this.$route.params.subject) {
              this.$router
                .replace({
                  name: 'introduce-teachers',
                  params: {
                    school_level: this.$route.params.school_level,
                    subject: this.subjects[0],
                  },
                })
                .catch(() => {});
            }
            this.state = 'display';
          },
          () => {
            this.state = 'error';
          }
        );
    },
    getTeachersBySubject(subject) {
      return this.teachers.filter((it) => it.subject == subject);
    },
    getSubjectName: getSubjectName,
  },
};

export default withApiClient(IntroduceTeachers);
</script>

<style lang="scss" scoped>
nav {
  margin: 50px auto;
  max-width: 540px;
  display: flex;
  justify-content: space-between;
}

.loading {
  text-align: center;
  margin: 30px;
}

@media (max-width: 1023px) {
  nav {
    margin: 15px auto 50px !important;
  }
}

@media (max-width: 480px) {
  nav {
    margin: 15px 40px 50px !important;
  }
}
</style>
